/**
 * @ngInject
 */

function Tracking() {
    var api = {};

    api.trackEvent = function trackEvent(category, action, label){
        if(typeof __gaTracker === "function"){
            __gaTracker('send', 'event', category, action, label);
        } else {
            console.warn("__gaTracker is not defined. GA data is not tracked:\nC: "+category+"\nA: "+action+"\nL: "+label);
        }
    }

    api.setDimension = function setDimension(dimension, value){
        if(typeof __gaTracker === "function"){
            __gaTracker('set', dimension, value);
        } else {
            console.warn("__gaTracker is not defined. GA dimension not set:\nD: "+dimension+"\nV: "+value);
        }
    }

    return api;
}